/**
 * To support sticky cells with borders, we need to apply `border-collapse: separate`
 * on the `<table>` element and we need to set a solid background color on the
 * sticky cells. But as a result of that, we can't apply borders or background
 * colors to the `<tr>` elements. We have to apply those styles to each individual
 * cell instead 😢.
 *
 * The constants in this file dedupe the utility classes that we need to apply
 * across multiple components.
 */

export const ROW_FOCUS_CLASSES =
  'shadow-transparent shadow-[inset_0_2px_0_0,inset_0_-2px_0_0] group-focus-visible/tr:shadow-thatch-500'

export const ROW_BG_CLASSES =
  'bg-white group-hover/tr:bg-gray-50 group-focus-visible/tr:bg-thatch-50'

export const ROW_BORDER_CLASSES = 'border-b border-gray-200'
